<template>
  <div
    v-bind="result.attributes"
    style="height: 100%"
    class="product-card-wrapper"
    @click="handlerClickGoogle"
    @mouseover="isMouseOver = true"
    @mouseleave="isMouseOver = false"
  >
    <div class="product-card">
      <DefLabels :result="result.labels" />
      <a :href="result.detailPage">
        <CardSlider :is-mouse-over="isMouseOver" :result="result.pictures" :is-gia="result.isGia" />
      </a>
      <DefLike v-if="isAuthorized" :result="result" />

      <DefColorsSmall :result="result" />

      <div v-if="screenWidth >= 992" class="product-card__view" @click="handlerOpenProductDetail">
        {{ messages.detail }}
      </div>
      <div v-if="result.price" class="product-card__block">
        <span v-if="result.offer.price.printDiscountPercent" class="product-card__discount">{{
          result.offer.price.printDiscountPercent
        }}</span>
        <a :href="result.detailPage" class="product-card__name">{{ result.name }}</a>
        <div>
          <span class="product-card__price">{{ result.offer.price.printPrice }}</span>
          <span
            v-if="+result.offer.price.printPrice !== +result.offer.price.printPriceOld"
            class="product-card__oldPrice"
            >{{ result.offer.price.printPriceOld }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DefLabels from '@components/Def/DefLabels/DefLabels.vue';
import CardSlider from '@components/sliders/CardSlider.vue';
import DefLike from '@components/Def/DefLike.vue';
import DefColorsSmall from '@components/Def/DefColors/DefColorsSmall.vue';
import { screenWidth } from '@use/useDeviceInfo';
import useModal from '@use/useModal/useModal';
import CatalogProductModal from '@components/Catalog/CatalogProductModal.vue';
import Analytics from '../../../utils/Analytics';

export default {
  name: 'ProductCard',
  components: {
    DefColorsSmall,
    DefLike,
    CardSlider,
    DefLabels,
  },
  props: {
    result: {
      type: Object,
    },
    messages: {
      type: Object,
      default: () => ({
        detail: 'Детальнее',
      }),
    },
    dataLayer: {
      type: Object,
    },
  },
  data() {
    return {
      screenWidth,
      modal: useModal(),
      isMouseOver: false,
    };
  },
  computed: {
    ...mapState({
      isAuthorized: ({ personal }) => personal.data.authInfo?.isAuthorized,
      pageNumber: ({ catalog }) => catalog.data.catalogSectionList?.pagination?.pageNumber,
    }),
  },
  methods: {
    ...mapActions({
      getPageData: 'product/getPageData',
    }),
    async handlerOpenProductDetail() {
      await this.getPageData({ url: this.result.detailPage });
      this.modal.show(CatalogProductModal, { dataLayer }, { width: '1024px', padding: false });
    },
    handlerClickGoogle() {
      try {
        Analytics.clickOnProduct(this.dataLayer);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.product-card {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  font-weight: 500;
  color: #191918;
  font-size: rem(14);
  letter-spacing: 0.08em;
  position: relative;
  height: 100%;
  @include point-md {
    font-size: rem(16);
  }

  &__discount {
    display: block;
    color: var(--discount-color);
    margin-bottom: 4px;
    font-size: rem(10);
    letter-spacing: 0.1em;
    height: 12px;
    @include point-md {
      font-size: rem(12);
    }
  }

  &__name {
    display: block;
    margin-bottom: 12px;
    @include point-md {
      margin-bottom: 18px;
    }
  }

  &__price {
    color: #363636;
  }

  &__oldPrice {
    color: #757575;
    text-decoration: line-through;
  }

  &__block {
    padding: 8px;
    @include point-md {
      padding: 16px;
    }
    @include point-lg {
      padding: 12px 24px 24px;
    }
  }

  &__view {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    background: var(--background-colour-primary);
    font-weight: 500;
    font-size: rem(14);
    text-transform: uppercase;
    color: #467496;
    opacity: 0;
    transition: 0.3s linear opacity;
    &:hover {
      cursor: pointer;
    }
  }

  &:hover {
    .product-card__view {
      opacity: 1;
    }
  }
  :deep(.def-like) {
    position: absolute;
    top: 16px;
    right: 16px;

    z-index: 1;
  }
  :deep(.def-labels) {
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 2;
  }
  :deep(.def-colors-small) {
    margin-bottom: 8px;
  }
}
.product-card-wrapper {
  height: 100%;
}
</style>
